module.exports = __webpack_public_path__ + "img/fk.45e63f5d.svg";